import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Pill.scss';

export default function Pill({ children, className }) {
	return (
		<div className={classnames('pill', className)}>
			{children}
		</div>
	);
}

Pill.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string
};
